<script setup>
import { defineProps, defineEmits } from 'vue';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

defineProps({
  showingOriginal: Boolean,
  isTranslating: Boolean,
  languageName: { type: String, default: '' },
});

defineEmits(['toggle']);
</script>

<template>
  <span
    v-if="isTranslating"
    class="text-xs text-n-slate-11 inline-flex items-center gap-1"
  >
    <Spinner :size="12" />
    {{ $t('CONVERSATION.TRANSLATING') }}
  </span>
  <span v-else class="text-xs text-n-slate-11 inline-flex items-center gap-1">
    <span v-if="languageName && !showingOriginal">
      {{ $t('CONVERSATION.TRANSLATED_TO', { language: languageName }) }}
      ·
    </span>
    <span
      class="cursor-pointer hover:underline select-none"
      @click="$emit('toggle')"
    >
      {{
        showingOriginal
          ? $t('CONVERSATION.VIEW_TRANSLATED')
          : $t('CONVERSATION.VIEW_ORIGINAL')
      }}
    </span>
  </span>
</template>
